angular
.module('inkfinder')

.run(function(
  $rootScope,
  $auth,
  Auth,
  AUTH_EVENTS,
  Session,
  $transitions,
  $location,
  Events,
  $document,
  _
) {
  // Boolean to determine if a state requires authentication
  let requiresAuth = {
    to: (state) => state.data && state.data.authorizedRoles
  };

  // Boolean to determine if a state requires authentication
  let doesNotRequireAuth = {
    to: (state) => !state.data
  };

  // Function to get the session if the state requires authentication so we can
  // validate the state transition based on the user credentials.
  let requiresSession = function(transition) {
    if ($auth.isAuthenticated() && _.isUndefined(Session.collector)) {
      return Auth.getSession().then(function() {
        return authorizeTransition(transition);
      });
    }
    return authorizeTransition(transition);
  };

  /**
   * @name loadSession
   * @description If the user has a token but no Session.collector (such as when
   * the browser is reloaded), then get the session.
   */
  function loadSession() {
    if ($auth.isAuthenticated() && _.isUndefined(Session.collector)) {
      Auth.getSession();
    }
  }

  // Before every state transition, check to see if authentication is required.
  $transitions.onBefore(requiresAuth, requiresSession, {priority: 10});
  $transitions.onBefore(doesNotRequireAuth, loadSession, {priority: 15});

  /**
   * @name authorizeTransition
   * @description Function to authorize if the user can view the to state.
   * @param {unknown} transition unknown.
   * @return {unknown} Returns target state.
   */
  function authorizeTransition(transition) {
    let $state = transition.router.stateService;
    let authorizedRoles = transition.to().data.authorizedRoles;
    if (Auth.isAllowed(authorizedRoles) === false) {
      $rootScope.$broadcast(AUTH_EVENTS.notAuthenticated);
      Auth.redirect.url = $location.path();
      return $state.target('login', undefined, {location: false});
    }
  }

  let requiresStateChange = {
    to: function(state) {
      if (state.data && state.data.authorizedRoles && Session.activeState) {
        return state.data.authorizedRoles.indexOf(Session.activeState.role) ===
        -1;
      }
    }
  };

  /**
   * @name changeState
   * @description Function to change the mode to match the role in data.
   * @return {function} changeState Returns the changeState function.
   */
  function changeState() {
    return Auth.changeState();
  }

  $transitions.onBefore(requiresStateChange, changeState, {priority: 20});

  $transitions.onStart({}, $transition$ => {
    let to = $transition$.to().name;
    let from = $transition$.from().name;
    if (to === 'inkfinder.messages.inbox' &&
    from === 'inkfinder.messages.conversations') {
      return;
    }
    Events.loading = true;
  });

  $transitions.onSuccess({}, () => {
    Events.loading = false;
  });

  $transitions.onFinish({}, () => {
    let top = 0;
    let duration = 500; // milliseconds
    $document.scrollTop(top, duration);
  });
});



// WEBPACK FOOTER //
// ./app.run.js